"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author gevorg.avetisyan on 4/27/2018.
 */
var IndicatorFrameworkService = /** @class */ (function () {
    function IndicatorFrameworkService() {
    }
    return IndicatorFrameworkService;
}());
exports.IndicatorFrameworkService = IndicatorFrameworkService;
//# sourceMappingURL=indicator-framework.service.js.map